import React from "react";
import { Avatar } from "../../types/types";
import { TCText } from "../TCText/TCText";
import { getInitials } from "../../utils/utils";

type props = {
  list: Avatar[];
  total?: number;
};

const MAX_IMAGES_TO_SHOW = 4;

export const SelectedCircleOverlapPlayerAvatars: React.FC<props> = ({
  list,
  total,
}) => {
  return (
    <div
      style={{
        flexDirection: "row",
        display: "flex",
        alignSelf: "center",
        justifyContent: "center",
        position: "relative",
      }}
    >
      {list.slice(0, MAX_IMAGES_TO_SHOW).map((avatar, index) =>
        avatar.image ? (
          <img
            key={index}
            src={avatar.image}
            alt=""
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              objectFit: "cover",
              marginLeft: index === 0 ? 0 : -5,
            }}
          />
        ) : (
          <div
            key={index}
            style={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              objectFit: "cover",
              marginLeft: index === 0 ? 0 : -5,
              backgroundColor: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <TCText
              style={{
                textAlign: "center",
                color: "white",
                fontWeight: 500,
                fontSize: 10,
              }}
              value={getInitials(avatar.name)}
            />
          </div>
        )
      )}
      {list.length > MAX_IMAGES_TO_SHOW && (
        <div
          style={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "white",
            fontSize: 10,
            fontWeight: 600,
            position: "absolute",
            right: 0,
          }}
        >
          +{(total ?? list.length) - MAX_IMAGES_TO_SHOW}
        </div>
      )}
    </div>
  );
};
